import { fmtDate } from "@/lib/api";
import { PrintHeader } from "@/components/PrintList";

const dia = (f) => new Date(`${f}T00:00:00`).toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" });
const Box = () => <span className="inline-block h-3.5 w-3.5 border border-slate-700 align-middle" />;
const th = "text-left border-b border-slate-700 font-semibold";
const td = "border-b border-slate-300 align-top";

export const PrintLlamadas = ({ items }) => (
  <div className="print-only" data-testid="print-llamadas">
    <PrintHeader title="Presupuestos sin respuesta: llamadas" detalle="Más de 7 días desde el envío o la última llamada" n={items.length} />
    <table className="w-full">
      <thead><tr>{["Paciente", "Teléfono", "Estado", "Desde", "Días", "Llamado", "Contesta", "Notas"].map((h) => <th key={h} className={th}>{h}</th>)}</tr></thead>
      <tbody>{items.map((b) => (
        <tr key={b.id}>
          <td className={td}>{b.paciente}</td><td className={td}>{b.telefono || "—"}</td><td className={td}>{b.estado === "DUDOSO" ? "Dudoso" : "Enviado"}</td>
          <td className={td}>{fmtDate(b.desde)}</td><td className={td}>{b.dias}</td><td className={td}><Box /></td><td className={td}><Box /> Sí <Box /> No</td>
          <td className={`${td} w-[35%]`}>&nbsp;</td>
        </tr>
      ))}</tbody>
    </table>
  </div>
);

const TIPO = { examen: "Examen", revision: "Revisión", alta: "Rev. alta" };

export const PrintRecuperar = ({ items }) => (
  <div className="print-only" data-testid="print-recuperar">
    <PrintHeader title="Sesiones por recuperar: dar cita" detalle="Quincenales y mensualidades" n={items.length} />
    <table className="w-full">
      <thead><tr>{["Paciente", "Teléfono", "Centro", "Tipo", "Por recuperar", "Próxima cita", "Cita dada", "Fecha y hora", "Notas"].map((h) => <th key={h} className={th}>{h}</th>)}</tr></thead>
      <tbody>{items.map((r) => (
        <tr key={r.treatment_id}>
          <td className={td}>{r.paciente}</td><td className={td}>{r.telefono || "—"}</td><td className={td}>{r.centro || "—"}</td><td className={td}>{r.modalidad}</td>
          <td className={td}>{r.recuperar}</td><td className={td}>{r.proxima ? fmtDate(r.proxima) : "Sin cita"}</td><td className={td}><Box /></td>
          <td className={`${td} w-[14%]`}>&nbsp;</td><td className={`${td} w-[20%]`}>&nbsp;</td>
        </tr>
      ))}</tbody>
    </table>
  </div>
);

export const PrintSinEmpezar = ({ items }) => (
  <div className="print-only" data-testid="print-sin-empezar">
    <PrintHeader title="Aprobados sin empezar: llamar y dar cita" detalle="Más de 15 días desde la aprobación, sin sesiones ni cita" n={items.length} />
    <table className="w-full">
      <thead><tr>{["Paciente", "Teléfono", "Centro", "Tratamiento", "Aprobado", "Días", "Llamado", "Cita dada", "Notas"].map((h) => <th key={h} className={th}>{h}</th>)}</tr></thead>
      <tbody>{items.map((r) => (
        <tr key={r.treatment_id}>
          <td className={td}>{r.paciente}</td><td className={td}>{r.telefono || "—"}</td><td className={td}>{r.centro || "—"}</td><td className={td}>{r.tipo}</td>
          <td className={td}>{fmtDate(r.desde)}</td><td className={td}>{r.dias}</td><td className={td}><Box /></td><td className={td}><Box /></td>
          <td className={`${td} w-[25%]`}>&nbsp;</td>
        </tr>
      ))}</tbody>
    </table>
  </div>
);

export const PrintSemana = ({ items }) => (
  <div className="print-only" data-testid="print-semana">
    <PrintHeader title="Exámenes y revisiones de la semana" detalle={items.length ? `${fmtDate(items[0].fecha)} – ${fmtDate(items[items.length - 1].fecha)}` : ""} n={items.length} />
    <table className="w-full">
      <thead><tr>{["Centro", "Tipo", "Paciente", "Teléfono", "Detalle", "Vino", "Notas"].map((h) => <th key={h} className={th}>{h}</th>)}</tr></thead>
      <tbody>{items.map((e, i) => [
        (i === 0 || items[i - 1].fecha !== e.fecha) && <tr key={`d${i}`}><td colSpan={7} className="pt-3 pb-1 font-bold uppercase border-b-2 border-slate-700">{dia(e.fecha)}</td></tr>,
        <tr key={i}>
          <td className={td}>{e.centro || "—"}</td><td className={td}>{TIPO[e.clase]}</td><td className={td}>{e.paciente}</td><td className={td}>{e.telefono || "—"}</td>
          <td className={td}>{e.tipo}</td><td className={td}><Box /></td><td className={`${td} w-[25%]`}>&nbsp;</td>
        </tr>,
      ])}</tbody>
    </table>
  </div>
);
